import { getApiBaseUrl } from './config';
import { apiRequest } from './client';
import { getApiToken } from './authToken';

export function objectFileName(file) {
  const safe = String(file?.name || 'file')
    .replace(/[^\w.\-()\s]/g, '')
    .replace(/\s+/g, '_')
    .slice(0, 120);
  return `${Date.now()}_${safe || 'file'}`;
}

export function objectPathFromUrl(url) {
  try {
    const parsed = new URL(url, window.location.origin);
    return String(parsed.searchParams.get('path') || '').trim();
  } catch {
    return '';
  }
}

export async function uploadFile(file, objectPath, { companyId, token, onProgress } = {}) {
  const authToken = token || (await getApiToken());
  const base = getApiBaseUrl();
  if (!base) throw new Error('API URL is not configured');

  const form = new FormData();
  form.append('file', file);
  form.append('path', objectPath);
  if (companyId) form.append('companyId', companyId);

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', `${base}/api/files`);
    xhr.setRequestHeader('Authorization', `Bearer ${authToken}`);
    xhr.setRequestHeader('Accept', 'application/json');
    if (onProgress) {
      xhr.upload.onprogress = (event) => {
        if (!event.lengthComputable) return;
        onProgress((event.loaded / event.total) * 100);
      };
    }
    xhr.onload = () => {
      let data = null;
      try {
        data = xhr.responseText ? JSON.parse(xhr.responseText) : null;
      } catch {
        data = { error: xhr.responseText };
      }
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve(data);
        return;
      }
      const error = new Error((data && data.error) || `API ${xhr.status}`);
      error.status = xhr.status;
      error.body = data;
      reject(error);
    };
    xhr.onerror = () => reject(new Error('Upload failed'));
    xhr.send(form);
  });
}

export async function deleteStoredFile(objectPath, { companyId, token } = {}) {
  if (!objectPath) return { ok: true };
  const authToken = token || (await getApiToken());
  try {
    return await apiRequest('/api/files', {
      token: authToken,
      method: 'DELETE',
      body: { path: objectPath, companyId: companyId || undefined },
    });
  } catch (error) {
    if (error?.status === 404) return { ok: true };
    throw error;
  }
}

export async function getFileUrl(objectPath, { companyId, token } = {}) {
  const authToken = token || (await getApiToken());
  const params = new URLSearchParams({ path: objectPath });
  if (companyId) params.set('companyId', companyId);
  return apiRequest(`/api/files/url?${params.toString()}`, { token: authToken });
}
